import { render, staticRenderFns } from "./StockviewActionBar.vue?vue&type=template&id=c8ff85ce&scoped=true&"
import script from "./StockviewActionBar.vue?vue&type=script&lang=js&"
export * from "./StockviewActionBar.vue?vue&type=script&lang=js&"
import style0 from "./StockviewActionBar.vue?vue&type=style&index=0&id=c8ff85ce&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ff85ce",
  null
  
)

export default component.exports